module.exports = __webpack_public_path__ + "assets/MaterialIcons-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/material-icons/iconfont/MaterialIcons-Regular.ttf
// module id = 952
// module chunks = 1